// ESR API host sent as `host` in subscription auth. Mocked in Jest
export function getViteAppEsrBaseUrl(): string {
  return import.meta.env.VITE_ESR_BASE_URL;
}
